import { Button } from "@/components/ui/button";
import { formatDate } from "@/lib/utils";
import { Plus } from "lucide-react";

interface Transaction {
  id: string;
  date: string;
  category: string;
  transaction_type: string;
  amount: number;
  status?: string;
  payee?: string;
}

interface RecentTransactionsTableProps {
  transactions: Transaction[];
  onViewMore?: () => void;
  onAddTransaction?: () => void;
}

export function RecentTransactionsTable({
  transactions,
  onViewMore,
  onAddTransaction,
}: RecentTransactionsTableProps) {
  return (
    <div>
      <div className="flex justify-between items-center mb-2">
        <h3 className="font-semibold">Recent Transactions</h3>
        <Button
          variant="link"
          onClick={onViewMore}
          className="px-0 h-auto text-primary"
        >
          View More
        </Button>
      </div>
      {transactions.length === 0 ? (
        <div className="border border-dashed border-muted-foreground/25 rounded-lg bg-muted/5 p-6 text-center">
          <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-3">
            <Plus className="w-6 h-6 text-primary" />
          </div>
          <p className="text-sm text-muted-foreground mb-3">
            No transactions yet
          </p>
          {onAddTransaction && (
            <Button size="sm" onClick={onAddTransaction} className="mx-auto">
              <Plus className="w-4 h-4 mr-2" />
              Add First Transaction
            </Button>
          )}
        </div>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr>
              <th>Date</th>
              <th>Category</th>
              <th>Type</th>
              <th className="text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {transactions.slice(0, 4).map((tx) => (
              <tr key={tx.id} className="border-b last:border-0">
                <td className="py-2 pr-4 whitespace-nowrap text-muted-foreground">
                  {formatDate(tx.date)}
                </td>
                <td className="py-2 pr-4">{tx.category}</td>
                <td className="py-2 pr-4">{tx.transaction_type}</td>
                <td
                  className={
                    tx.amount < 0
                      ? "text-red-500 py-2 pr-4 text-right"
                      : "py-2 pr-4 text-right"
                  }
                >
                  {tx.amount < 0 ? "-" : ""}$
                  {Math.abs(tx.amount).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
